// SearchResults.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import bgImage from '../assets/Background.png';



function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SearchResults() {
  const query = useQuery();
  const searchTerm = query.get("q");
  const [loading, setLoading] = useState(true);
  const [matches, setMatches] = useState([]);
  const [all, setAll] = useState([]);
  const navigate = useNavigate();


// for send query system

const [showQueryModal, setShowQueryModal] = useState(false);
const [queryCourse, setQueryCourse] = useState("");
const [queryUniversity, setQueryUniversity] = useState("");
const [queryForm, setQueryForm] = useState({
  studentName: "",
  studentPhone: "",
  studentEmail: "",
  message: ""
});
const [queryError, setQueryError] = useState("");
const [querySuccess, setQuerySuccess] = useState("");

const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
const API_BASE = isDev ? "http://localhost:5000" : "";



  useEffect(() => {
    setLoading(true);
    fetch(`/api/institutes/search-courses?q=${encodeURIComponent(searchTerm || "")}`)
      .then(res => res.json())
      .then(data => {
        setMatches(data.matches || []);
        setAll(data.all || []);
        setLoading(false);
      });
  }, [searchTerm]);

  return (
    <div
  style={{
    padding: "36px 12px",
    minHeight: "100vh",
    // backgroundImage removed!
  }}
>

      <h2 style={{
        fontWeight: "bold",
        color: "#f5f5f5ff",
        fontSize: "2.2rem",
        marginBottom: "20px"
      }}>
        Search Results
      </h2>
     
      {loading ? (
        <div style={{ margin: "64px", color: "#888" }}>Loading...</div>
      ) : (
        <>
          <div>
            <h4 style={{ marginTop: "30px", color: "#e2e3e3ff",  }}>Universities Offering {searchTerm}</h4>
            {matches.length === 0 ? (
              <div style={{ color: "#a00", margin: "22px 0" }}>No universities found for this programme.</div>
            ) : (
              <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "28px",
                margin: "32px 0 48px 0"
              }}>
                {matches.map((inst) => {
  // Count total number of programs
  const totalPrograms = Array.isArray(inst.departments)
    ? inst.departments.reduce((acc, dep) => acc + (dep.courses?.length || 0), 0)
    : 0;

  return (
    <div
      key={inst._id}
      style={{
        background: "#fff",
        borderRadius: "18px",
        boxShadow: "0 4px 14px rgba(44,70,120,0.13)",
        width: 310,
        minHeight: 295,
        margin: "0 0 28px 0",
        cursor: "pointer",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        transition: "box-shadow 0.22s"
      }}
      onClick={() => navigate(`/institute/${inst._id}`)}
    >
    {/* Cover Photo */}
<div style={{
  height: "116px",
  width: "100%",
  background: "#eaf2fc",
  position: "relative"
}}>
  {/* Cover Image */}
  <img
    src={inst.coverUrl ? API_BASE + inst.coverUrl : "/default-campus.jpg"}

    alt="Cover"
    style={{
      height: "100%",
      width: "100%",
      objectFit: "cover"
    }}
  />

  {/* University Logo with background thumbnail - top-left */}
  <div style={{
    position: "absolute",
    top: "5px",       // Adjust vertical position
    left: "5px",      // Use 'right' instead for top-right
    background: "#578be3ff", // CHANGE this color to any (e.g., "#2b4b83ff", "#f3f7fd", "rgba(0,0,0,0.18)" etc.)
    borderRadius: "18px",  // "50%" for circle, "18px" for soft square
    width: 64,         // background width (change to 74, 80 etc)
    height: 40,        // background height (change as needed)
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 12px rgba(40,116,250,0.08)", // subtle shadow
    border: "2.5px solid #eaf2fc",                 // border color/size
    zIndex: 2
  }}>
    <img
      src={inst.logoUrl ? API_BASE + inst.logoUrl : "/default-logo.png"}

      alt="Logo"
      style={{
        width: 48,          // Logo size inside background (change to 56 etc)
        height: 48,
        objectFit: "contain",
        background: "none",
        border: "none",
        borderRadius: "0",
        boxShadow: "none"
      }}
    />
  </div>
</div>





      <div style={{ padding: "38px 18px 18px 18px", flex: 1 }}>
        {/* Course name (if searching by course) */}
        {searchTerm && (
          <div style={{
            fontWeight: 700,
            fontSize: "1.09rem",
            color: "#1870d6",
            marginBottom: "6px"
          }}>
            {searchTerm}
          </div>
        )}
        {/* University Name */}
        <div style={{
          fontWeight: 700,
          fontSize: "1.13rem",
          color: "#214a6d",
          marginBottom: "6px"
        }}>
          {inst.name}
        </div>
        {/* Number of programs */}
        <div style={{
          color: "#506d8f",
          fontSize: "0.97rem",
          marginBottom: "2px"
        }}>
          {totalPrograms} programmes offered
        </div>
      </div>
      <button
  style={{
    marginTop: "12px",
    padding: "7px 16px",
    fontSize: "1.08rem",
    background: "#2874fa",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(40,116,250,0.11)",
    fontWeight: 600
  }}
  onClick={e => {
    e.stopPropagation(); // Prevents card click navigation
    setQueryCourse(searchTerm || "");
    setQueryUniversity(inst.name || "");
    setShowQueryModal(true);
    setQueryForm({ studentName: "", studentPhone: "", studentEmail: "", message: "" });
    setQueryError("");
    setQuerySuccess("");
  }}
>
  Send Query
</button>
    </div>
  );
})}
</div>
 )}
</div>

          <div>
            <h5 style={{ margin: "34px 0 14px 0",  color: "#f5f5f5ff", }}>Explore Other Universities</h5>
            <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "18px",
              margin: "14px 0 48px 0"
            }}>
              {all.map((inst) => {
  const totalPrograms = Array.isArray(inst.departments)
    ? inst.departments.reduce((acc, dep) => acc + (dep.courses?.length || 0), 0)
    : 0;

  return (
    <div
      key={inst._id}
      style={{
        background: "#fff",
        borderRadius: "18px",
        boxShadow: "0 4px 14px rgba(44,70,120,0.13)",
        width: 310,
        minHeight: 265,
        margin: "0 0 28px 0",
        cursor: "pointer",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        transition: "box-shadow 0.22s"
      }}
      onClick={() => navigate(`/institute/${inst._id}`)}
    >
      {/* Cover image */}
      <div style={{
        height: "116px",
        width: "100%",
        background: "#eaf2fc",
        position: "relative"
      }}>
        <img
          src={inst.coverUrl ? API_BASE + inst.coverUrl : "/default-campus.jpg"}
          alt="Cover"
          style={{
            height: "100%",
            width: "100%",
            objectFit: "cover"
          }}
        />
        {/* University logo, positioned top-left, no border or background */}
        <img
          src={inst.logoUrl ? API_BASE + inst.logoUrl : "/default-logo.png"}

          alt="Logo"
          style={{
            position: "absolute",
            top: "14px",
            left: "14px",
            height: "52px",
            width: "52px",
            objectFit: "contain",
            zIndex: 2,
            background: "none",
            border: "none",
            borderRadius: "0"
          }}
        />
      </div>
      <div style={{ padding: "38px 18px 18px 18px", flex: 1 }}>
        {/* University Name */}
        <div style={{
          fontWeight: 700,
          fontSize: "1.13rem",
          color: "#214a6d",
          marginBottom: "6px"
        }}>
          {inst.name}
        </div>
        {/* Number of programs */}
        <div style={{
          color: "#506d8f",
          fontSize: "0.97rem",
          marginBottom: "2px"
        }}>
          {totalPrograms} programmes offered
        </div>
      </div>
    </div>
  );
})}

            </div>
          </div>
        </>
      )}

{showQueryModal && (
  <div style={{
    position: "fixed",
    top: 0, left: 0, width: "100vw", height: "100vh",
    background: "rgba(50,60,80,0.21)",
    zIndex: 8888,
    display: "flex", alignItems: "center", justifyContent: "center"
  }}>
    <div style={{
      background: "#fff",
      borderRadius: "18px",
      minWidth: "330px",
      maxWidth: "95vw",
      padding: "36px 24px 24px 24px",
      boxShadow: "0 4px 32px rgba(44,70,120,0.17)",
      position: "relative"
    }}>
      <button
        onClick={() => setShowQueryModal(false)}
        style={{
          position: "absolute",
          top: 14, right: 18,
          background: "none",
          border: "none",
          fontSize: "1.8rem",
          color: "#666",
          cursor: "pointer"
        }}
        aria-label="Close"
      >×</button>
      <h3 style={{ margin: 0, marginBottom: 20, color: "#2874fa" }}>Send Query</h3>
      {queryError && <div style={{ color: "red", marginBottom: 10 }}>{queryError}</div>}
      {querySuccess && <div style={{ color: "green", marginBottom: 10 }}>{querySuccess}</div>}
     <form
  onSubmit={async e => {
    e.preventDefault();
    setQueryError("");
    setQuerySuccess("");
    // Validate required fields
    if (!queryForm.studentName || !queryForm.studentPhone || !queryForm.studentEmail) {
      setQueryError("Please fill all required fields.");
      return;
    }
    try {
      const res = await fetch('/api/student/send-query', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          courseName: queryCourse,
          universityName: queryUniversity,
          studentName: queryForm.studentName,
          studentPhone: queryForm.studentPhone,
          studentEmail: queryForm.studentEmail,
          message: queryForm.message
        })
      });
      const data = await res.json();
      if (!res.ok) {
        setQueryError(data.message || "Could not send query. Try again.");
      } else {
        setQuerySuccess("Query sent successfully!");
        setTimeout(() => setShowQueryModal(false), 1400);
      }
    } catch {
      setQueryError("Server error. Please try again.");
    }
  }}
>

  <div style={{
    display: "flex",
    gap: "10px",
    marginBottom: 14,
    flexWrap: "wrap"
  }}>
    <div style={{ flex: "1 1 150px", minWidth: 120 }}>
      <label style={{ fontWeight: 500, color: "#1870d6" }}>
        Course Name:<br />
        <input
          type="text"
          value={queryCourse}
          readOnly
          style={{
            width: "100%",
            background: "#f2f7fb",
            border: "1px solid #d7e3ef",
            borderRadius: "6px",
            padding: "7px"
          }}
        />
      </label>
    </div>
    <div style={{ flex: "1 1 180px", minWidth: 140 }}>
      <label style={{ fontWeight: 500, color: "#1870d6" }}>
        University:<br />
        <input
          type="text"
          value={queryUniversity}
          readOnly
          style={{
            width: "100%",
            background: "#f2f7fb",
            border: "1px solid #d7e3ef",
            borderRadius: "6px",
            padding: "7px"
          }}
        />
      </label>
    </div>
    <div style={{ flex: "1 1 140px", minWidth: 120 }}>
      <label>
        Your Name:*<br />
        <input
          type="text"
          required
          value={queryForm.studentName}
          onChange={e => setQueryForm({ ...queryForm, studentName: e.target.value })}
          style={{ width: "100%", padding: "7px" }}
        />
      </label>
    </div>
    <div style={{ flex: "1 1 140px", minWidth: 120 }}>
      <label>
        Phone Number:*<br />
        <input
          type="tel"
          required
          value={queryForm.studentPhone}
          onChange={e => setQueryForm({ ...queryForm, studentPhone: e.target.value })}
          style={{ width: "100%", padding: "7px" }}
        />
      </label>
    </div>
    <div style={{ flex: "1 1 160px", minWidth: 130 }}>
      <label>
        Email:*<br />
        <input
          type="email"
          required
          value={queryForm.studentEmail}
          onChange={e => setQueryForm({ ...queryForm, studentEmail: e.target.value })}
          style={{ width: "100%", padding: "7px" }}
        />
      </label>
    </div>
    <div style={{ flex: "2 1 200px", minWidth: 170 }}>
      <label>
        Message:<br />
        <textarea
          value={queryForm.message}
          onChange={e => setQueryForm({ ...queryForm, message: e.target.value })}
          placeholder="(Optional)"
          style={{
            width: "100%",
            minHeight: 40,
            padding: "7px",
            resize: "vertical"
          }}
        />
      </label>
    </div>
  </div>
  <button
    type="submit"
    style={{
      marginTop: 8,
      width: "100%",
      padding: "10px 0",
      fontSize: "1.13rem",
      background: "#2874fa",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: 600
    }}
  >
    Send
  </button>
</form>

    </div>
  </div>
)}



    </div>
  );
}

export default SearchResults;
